import { render, staticRenderFns } from "./CreateDistrict.vue?vue&type=template&id=0c51bfb2&scoped=true&"
import script from "./CreateDistrict.vue?vue&type=script&lang=js&"
export * from "./CreateDistrict.vue?vue&type=script&lang=js&"
import style0 from "./CreateDistrict.vue?vue&type=style&index=0&id=0c51bfb2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c51bfb2",
  null
  
)

export default component.exports